import { useEffect, useRef } from "react";

function lockCursor(cursor) {
    const style = document.createElement("style");
    style.setAttribute("data-cursor-lock", "");
    style.innerHTML = `
      * {
        cursor: ${cursor} !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  function unlockCursor() {
    const style = document.querySelector("style[data-cursor-lock]");
    if (style) style.remove();
  }

  
export function useScrubInput({ value, onChange, onCommit, step = 1 }) {
    const startX = useRef(0);
    const startValue = useRef(0);
    const dragging = useRef(false);
  
    const onMouseDown = (e) => {
    //   e.preventDefault();
    //   e.stopPropagation();
  
      dragging.current = true;
      startX.current = e.clientX;
      startValue.current = parseFloat(value) || 0;

      lockCursor("ew-resize");
  
      document.body.style.cursor = "ew-resize";
      document.body.style.userSelect = "none";
    };
  
    useEffect(() => {
      const onMouseMove = (e) => {
        if (!dragging.current) return;
  
        const delta = e.clientX - startX.current;
        const next = Math.max(1, startValue.current + delta * step);
  
        onChange(next.toFixed(1));
        onCommit?.(next);
      };
  
      const onMouseUp = () => {
        if (!dragging.current) return;
  
        dragging.current = false;
        unlockCursor();
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };
  
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
  
      return () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
      };
    }, [onChange, onCommit, step]);
  
    return {
      onMouseDown,
      isDragging: dragging,
    };
  }
  